/* eslint-disable @typescript-eslint/no-explicit-any */
import { Languages, ProductCardType } from '@/constants'
import { labelPositionProductCard } from '@/constants/positions'
import { useCart, useNotification } from '@/containers'
import type { Product } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import clsx from 'clsx'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
import Price from '../Price'
import PriceRelated from '../Price/PriceRelated'
import ProgressBar from '../ProgressBar'
import Countdown from './Countdown'
// import PolicyCard from './PolicyCard'
export interface ProductProps {
  product: Product
  type?: string
  layout?: number
  className?: string
  border?: boolean
}

const ProductCard = ({
  className,
  product,
  type,
  layout,
  border = false,
}: ProductProps) => {
  const { systemConfig } = useNotification()
  const { setSelectedProductBuyNow, setIsOpenBuyNow } = useCart()
  const discountAmount = product?.price - product?.finalPrice
  const discountPercent =
    ((product?.price - product?.finalPrice) / product?.price) * 100

  return (
    <div
      className={clsx(
        'productCard relative',
        className,
        type,
        layout && `l${layout}`
      )}
    >
      <div
        className={clsx(
          'itemProducts h-full items-center overflow-hidden rounded-lg pb-7 relative',
          layout && `l${layout}`,
          border && 'border border-white-500'
        )}
      >
        <div className='image-thumb relative block w-full p-1'>
          {product?.labels &&
            product?.labels
              ?.filter(e => e?._id)
              ?.map((item, index) => {
                return (
                  <span
                    className={`${labelPositionProductCard.get(
                      item?.position
                    )} label absolute flex gap-x-2 flex-nowrap overflow-x-auto overflow-y-hidden hiddenScrollBar w-full h-auto`}
                    key={index}
                    style={{ zIndex: 50 + index }}
                  >
                    <ImageOptimize
                      src={item?.image}
                      alt={getTranslate(item?.name)}
                      width={200}
                      height={48}
                      loading='lazy'
                      className={`w-full h-auto`}
                    />
                  </span>
                )
              })}
          <Link
            href={
              '/' +
              getTranslate(product?.slugs?.value) +
              product?.slugs?.postfix
            }
            className='relative block w-full overflow-hidden pt-[100%] focus:border-0 focus:outline-0'
          >
            <ImageOptimize
              className='productImage absolute left-0 top-0 aspect-square h-full w-full object-cover'
              src={
                product?.thumbnail
                  ? product?.thumbnail
                  : systemConfig?.imageWarehousePlaceholder ||
                    process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
                    ''
              }
              alt={getTranslate(product?.name)}
              width={300}
              height={300}
              loading='lazy'
              thumbnail
            />
          </Link>
          {discountPercent >= 30 ? (
            <div className='absolute bottom-0 left-2 w-max overflow-hidden rounded-md bg-[url(/assets/images/bg-label-1.png)] bg-cover bg-no-repeat'>
              <div className='content flex flex-col px-1.5 py-[3px] leading-tight'>
                <span className='text-[10px] italic text-white'>Tiết kiệm</span>
                <span className='text-xs font-bold text-yellow-500'>
                  {discountAmount &&
                    discountAmount
                      .toLocaleString(Languages.VN, {
                        style: 'currency',
                        currency: 'VND',
                      })
                      .replace(/\s₫/g, 'đ')}
                </span>
              </div>
            </div>
          ) : (
            ''
          )}
          {product?.flashSale && type != ProductCardType.TRENDING && (
            <Countdown
              productId={product?._id}
              endTime={product?.flashSale?.endTime}
              type={ProductCardType.PRODUCT_CARD}
              className={
                type == ProductCardType.RELATED ? 'justify-center bottom-2' : ''
              }
            />
          )}
        </div>
        <div
          className={clsx(
            'w-full pt-1 text-left',
            type === ProductCardType.FLASH_SALE && 'px-2',
            type !== ProductCardType.RELATED && 'p-2',
            type === 'list' && 'pb-2',
            type === ProductCardType.TRENDING &&
              'rounded-b-sm border border-t-0 px-4 pb-3'
          )}
        >
          <Link
            href={
              '/' +
              getTranslate(product?.slugs?.value) +
              product?.slugs?.postfix
            }
            className={`${
              type == ProductCardType.RELATED ? '' : ''
            } mb-1 line-clamp-2 block h-8 overflow-hidden text-ellipsis text-xs leading-4 text-dark-400 focus:border-0 focus:outline-none`}
          >
            {getTranslate(product?.name)}
          </Link>
          {type === ProductCardType.RELATED ? (
            <PriceRelated
              type={ProductCardType.PRODUCT_CARD}
              classes=''
              link={
                '/' +
                getTranslate(product?.slugs?.value) +
                product?.slugs?.postfix
              }
              originPrice={product?.price}
              finalPrice={product?.finalPrice}
            />
          ) : (
            <Price
              type={ProductCardType.PRODUCT_CARD}
              classes=''
              link={
                '/' +
                getTranslate(product?.slugs?.value) +
                product?.slugs?.postfix
              }
              originPrice={product?.price}
              finalPrice={product?.finalPrice}
            />
          )}

          {product?.flashSale && (
            <div className={`h-[28px] pt-0.5 list`}>
              <ProgressBar
                fsType={product.type}
                flashSale={product?.flashSale}
                type={ProductCardType.PRODUCT_CARD}
              />
            </div>
          )}
        </div>

        <div className='actionCard absolute bottom-0 right-0 flex h-7 w-full justify-end z-10'>
          <button
            type='button'
            onClick={() => {
              setIsOpenBuyNow(true)
              setSelectedProductBuyNow(getTranslate(product?.name))
            }}
            className='rounded-tl-lg bg-primary-base px-4 text-xs font-semibold text-white'
          >
            Mua ngay
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProductCard
